import * as Models from '../../models';

export const COUNTRIES: Models.MD.Country[] = [
  { id: 229, name: 'United States', code: 229 },
  { id: 95, name: 'India', code: 95 },
  { id: 135, name: 'Mexico', code: 135 },
  { id: 43, name: 'Chile', code: 43 },
  { id: 38, name: 'Canada', code: 38 },
  
];
